import { useCallback, useEffect, useState } from 'react';

// Состояние действий над выбранными строками таблицы остатков:
// иконка-карандаш в шапке показывает/скрывает кнопку «С выбранными», режим редактирования строк включается только из её меню.
export const useSelectedActions = (hasSelection: boolean) => {
    const [actionsVisible, setActionsVisible] = useState(false);
    const [editingMode, setEditingMode] = useState(false);

    useEffect(() => {
        if (!hasSelection) {
            setActionsVisible(false);
            setEditingMode(false);
        }
    }, [hasSelection]);

    const toggleActions = useCallback(() => {
        setActionsVisible((visible) => {
            if (visible) setEditingMode(false);
            return !visible;
        });
    }, []);

    return { actionsVisible, editingMode, setEditingMode, toggleActions };
};
